<template>
	<LayoutFlex padding="0" gap="var(--size-32)">
		<PortalPageHeader :title="title" :subtitle="subtitle">
			<template v-if="$slots.action" #action>
				<slot name="action" />
			</template>
		</PortalPageHeader>
		<slot />
	</LayoutFlex>
</template>

<script setup lang="ts">
import { LayoutFlex } from '@simple-life-app/growth-ui-kova'
import PortalPageHeader from './PortalPageHeader.vue'

/**
 * A section page: the page header (title, subtitle, the one `action`) and the page's blocks under it, 32
 * apart (Figma 13833:136102 "Container"). Every section view is one of these — the outlet's content, no
 * `LayoutScreen` of its own: docs/architecture/portal.md → "Building a section page".
 */

defineProps<{
	title: string
	subtitle?: string
}>()
</script>
